import { Chip, Grid, Typography, useMediaQuery } from '@material-ui/core';
import React, { useContext } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import FlexView from 'react-flexview/lib';
import { QuoteContextStore } from '../../context/QuoteContext/QuoteContext';
import { SessionContextStore } from '../../context/SessionContext/SessionContext';

const FlowTitle = () => {
    const { title } = useContext(QuoteContextStore);
    const { impersonationDetails } = useContext(SessionContextStore);
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    return (
        <React.Fragment>
        { !isMobile ?
        // className="margin-top-large padding-left-large"
            <div className="step-title">
                <Grid container justifyContent="left" alignItems='center'>
                    <Typography variant="h1" className="blue">{title}</Typography>
                    { impersonationDetails && <Chip className='margin-left-6' label={impersonationDetails.email} /> }
                </Grid>
            </div>
            :
            <FlexView className="margin-top-medium space-between step-title" hAlignContent="center" vAlignContent={'center'}>
                <FlexView vAlignContent={'center'}>
                    <FlexView column vAlignContent={'center'} >
                    <Typography variant="h1" className="blue">{title}</Typography>
                    { impersonationDetails && <Chip label={impersonationDetails.email} /> }
                    </FlexView>
                </FlexView>
            </FlexView>}
        </React.Fragment>
    );
}

export default FlowTitle;